import { Phone, Mail } from "lucide-react";
import { useLegalDialog } from "@/components/LegalDialog";

const Footer = () => {
  const { trigger, dialog } = useLegalDialog();

  return (
    <footer className="bg-dark py-12 border-t border-dark-foreground/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-primary mb-3">אור בגג</h3>
            <p className="text-dark-foreground/70 leading-relaxed">
              מומחה גגות ופחחות עם 13 שנות ניסיון. פתרון מקצועי ואמין לכל בעיות הגג.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-dark-foreground mb-3">קישורים</h4>
            <ul className="space-y-2">
              {[
                { label: "שירותים", href: "#services" },
                { label: "אודות", href: "#about" },
                { label: "גלריה", href: "#gallery" },
                { label: "צור קשר", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-dark-foreground/70 hover:text-primary transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-dark-foreground mb-3">פרטי קשר</h4>
            <div className="space-y-3">
              <a href="tel:+972545725681" className="flex items-center gap-2 text-dark-foreground/70 hover:text-primary transition-colors">
                <Phone size={16} />
                <span dir="ltr">054-572-5681</span>
              </a>
              <a href="mailto:Orbagag@gmail.com" className="flex items-center gap-2 text-dark-foreground/70 hover:text-primary transition-colors">
                <Mail size={16} />
                <span>Orbagag@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-foreground/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-dark-foreground/50">
          <p>© {new Date().getFullYear()} אור בגג. כל הזכויות שמורות.</p>
          <a
            href="https://www.onspote.com"
            target="_blank"
            rel="noopener noreferrer"
            dir="ltr"
            className="text-dark-foreground/40 hover:text-primary transition-all duration-300 hover:-translate-y-1 inline-block text-base"
          >
            OnSpote אופיין ועוצב על ידי
          </a>
          <div className="flex gap-4">
            <button onClick={() => trigger("terms")} className="hover:text-primary transition-colors">תקנון</button>
            <button onClick={() => trigger("privacy")} className="hover:text-primary transition-colors">מדיניות פרטיות</button>
            <button onClick={() => trigger("accessibility")} className="hover:text-primary transition-colors">הצהרת נגישות</button>
          </div>
        </div>
      </div>
      {dialog}
    </footer>
  );
};

export default Footer;
